import React from "react";
//#region types
import
{ GraphConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { SupplierChartProps } from "models/propTypes/supplierPropTypes";
//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const InvoiceTotalByCategoryChart: React.FC<SupplierChartProps> = (props) => {
  const filter: Omit<WintSuperkollAPIModel.IncomingInvoiceFilter, keyof WintUtilsWebApi.Filter> = {
    onlyMine: false,
    supplierId: props.supplierId,
  };

  const chartLabelFormatter = (label?: string) => {
    if (!label) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NotSelected);
    }

    return label;
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.SupplierInvoiceTotal12Months}
      chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PostedAs)}
      labelFormatter={chartLabelFormatter}
      filter={filter}
    />
  );
};

export default InvoiceTotalByCategoryChart;
